import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { hasMacroPermission } from 'src/app/utils/cookie-utils';
import { MacroPermission } from 'src/app/_models/macro-permissions.enum';

@Component({
  selector: 'app-responsable-sidebar',
  templateUrl: './responsable-sidebar.component.html',
  styleUrls: ['./responsable-sidebar.component.scss']
})
export class ResponsableSidebarComponent implements OnInit {
  constructor(private router: Router) { }

  ngOnInit(): void {
    // Si l'utilisateur est un opérateur, rediriger automatiquement vers les lots de transfert
    if (this.isOperator() && this.router.url === '/welcome/menu/bancassurance/responsable-menus') {
      this.router.navigate(['/welcome/menu/bancassurance/responsable-virements']);
    }
  }

  hasManagerVisualizePolicePermission(): boolean {
    return hasMacroPermission(MacroPermission.ManagerVisualizePolice);
  }

  hasBatchTransfertPermission(): boolean {
    return hasMacroPermission(MacroPermission.BatchTransfert);
  }

  hasCreatePolicePermission(): boolean {
    return hasMacroPermission(MacroPermission.CreatePolice);
  }

  hasCreateClaimsPermission(): boolean { return hasMacroPermission(MacroPermission.CreateClaims); } // Ajout de la fonction hasCreateClaimsPermission
hasReadOnlyCoEnssurancePermission(): boolean { return hasMacroPermission(MacroPermission.ReadOnlyCoEnssurance); } // Ajout de la fonction hasReadOnlyCoEnssurancePermission
hasReadOnlyCommissionPermission(): boolean { return hasMacroPermission(MacroPermission.ReadOnlyCommission); } // Ajout de la fonction hasReadOnlyCommissionPermission
  hasManagerVisualizeclaimsPermission(): boolean { return hasMacroPermission(MacroPermission.ClaimVisualize); } // Ajout de la fonction hasManagerVisualizePermission
/**
   * Vérifie si l'utilisateur est un opérateur (a BatchTransfert mais pas ManagerVisualizePolice)
   */
  isOperator(): boolean {
    return this.hasBatchTransfertPermission() && !this.hasManagerVisualizePolicePermission();
  }

  navigate(route: string): void {
    this.router.navigate([route]);
  }

   goToHome(): void {
    this.router.navigate(['/welcome/menu/bancassurance/responsable-menus']);
  }
}
